import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";


export const PaymentAPI = {

  getPublishKey: async function () {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/publish-key`,
      method: "GET",
      withCredentials: true,
      // timeout: 5000, 
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getAdminConnectedAccountId: async function (reqData) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/account-id`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000, 
      data: reqData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


  getPaymentDefaultCard: async function (userId, clubId) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/get-default-card/` + userId + `/club/` + clubId,
      method: "GET",
      withCredentials: true,
      // timeout: 5000, 
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


  getInvoicesForAdmin: async function (userId, clubId) {

    const response = await axiosInstance.request({
      url: `/ecommerce/invoice/customer/${userId}/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      // timeout: 5000, 
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


  getPaymentHistory: async function (userId, clubId, pageData) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/payment-history/userId/` + userId + `/club/` + clubId,
      method: "POST",
      withCredentials: true,
      data: pageData,
      // timeout: 5000, 
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getAllPaymentHistory: async function (clubId, pageSize, pageNumber, paymentMode, searchKey, filterData) {
    const response = await axiosInstance.request({
      url: `/payment-history/${clubId}?pageSize=${pageSize}&pageNumber=${pageNumber}&paymentMode=${paymentMode}&searchKey=${searchKey}`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000, 
      data: filterData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
    getAllPaymentHistoryByUser: async function (clubId,userId, pageSize, pageNumber, paymentMode, searchKey,filterData) {
    const response = await axiosInstance.request({
      url: `/payment-history/${clubId}/user/${userId}?pageSize=${pageSize}&pageNumber=${pageNumber}&paymentMode=${paymentMode}&searchKey=${searchKey}`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000, 
      data: filterData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getTotalPaymentHistory: async function (clubId, paymentMode) {
    const response = await axiosInstance.request({
      url: `/payment-history/total/${clubId}?paymentMode=${paymentMode}`,
      method: "GET",
      withCredentials: true,
      // timeout: 5000, 
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


  downloadPaymentHistory: async function (clubId, dateRange, paymentMode) {
    const response = await axiosInstance.request({
      url: `/payment-history/report/${clubId}?dateRange=${dateRange}&paymentMode=${paymentMode}`,
      method: "GET",
      withCredentials: true,
      responseType: 'blob',
      // timeout: 5000, 
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },



  postSetPaymentDefaultCard: async function (paymentDefaultCard) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/set-default-payment-method`,
      method: "POST",
      withCredentials: true,
      timeout: 10000,
      data: paymentDefaultCard,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postCreatePayment: async function (createPaymentInfo) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/create-payment`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data: createPaymentInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postCancelPaymentIntent: async function (cancelPaymentInfo) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/cancel-payment-intent`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000, 
      data: cancelPaymentInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postCalculatePricing: async function (paymentInfo) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/calculate`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000, 
      data: paymentInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postCalculateEventSchedulePricing: async function (paymentInfo) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/calculate/event/schedule`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000, 
      data: paymentInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


  postCreatePaymentIntent: async function (paymentIntentDetails) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/create-payment-intent`,
      method: "POST",
      withCredentials: true,
      timeout: 20000,
      data: paymentIntentDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postCreatePaymentIntentForEvent: async function (paymentIntentDetails) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/event/create-payment-intent`,
      method: "POST",
      withCredentials: true,
      timeout: 20000,
      data: paymentIntentDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postCreatePaymentIntentForGuardianPayEvent: async function (paymentIntentDetails) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/event/user/create-payment-intent`,
      method: "POST",
      withCredentials: true,
      timeout: 20000,
      data: paymentIntentDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postOfflinePaymentForSeason: async function (paymentIntentDetails) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/event/offline-payment`,
      method: "POST",
      withCredentials: true,
      timeout: 20000,
      data: paymentIntentDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postGuardianOfflinePaymentForSeason: async function (paymentIntentDetails) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/event/user/offline-payment`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data: paymentIntentDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postProcessFreeEvent: async function (paymentIntentDetails) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/free/event`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data: paymentIntentDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postMakePaymentWithDefaultCard: async function (paymentIntentDetails) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/make-payment-with-default-card`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000, 
      data: paymentIntentDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postCreateBankPaymentIntent: async function (paymentBankIntentDetails) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/create-setup-intent-bank`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data: paymentBankIntentDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getIsBankMethodExist: async function (paymentId, userId, clubId) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/is-bank-payment-method-exist/` + paymentId + `/userId/` + userId + `/club/` + clubId,
      method: "GET",
      withCredentials: true,
      timeout: 1000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getBankPaymentMethods: async function (userId) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/fetch-bank-payment-methods/userId/` + userId,
      method: "GET",
      withCredentials: true,
      timeout: 1000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


  getUnConfirmPaymentMethod: async function (paymentMethodId) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/get-un-confirm-payment-method/` + paymentMethodId,
      method: "GET",
      withCredentials: true,
      timeout: 1000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


  getCardDetailsByPymtMethodId: async function (pymtMethodId) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/payment-method/` + pymtMethodId,
      method: "GET",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  fetchAllPaymentMethods: async function (userId, clubId) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/all-payment-methods/` + userId + `/club/` + clubId,
      method: "GET",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  fetchDefaultPaymentMethodData: async function (userId, clubId) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/get-default-card-data/` + userId + `/club/` + clubId,
      method: "GET",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  fetchReceiptUrl: async (userId, clubId, paymentIntentId) => {
    try {
      const response = await axiosInstance.request({
        url: `/ecommerce/invoice/receipt/user/${userId}/club/${clubId}?paymentIntentId=${paymentIntentId}`,
        method: 'GET',
        responseType: 'blob',
          headers: {
            'Accept': 'application/pdf',
            Authorization: `Bearer ${getToken()}`
          }
        
        });
      return response.data;

    } catch (error) {
      console.error('Error fetching receipt:', error);
      throw error;
    }
  },

  postCreateSetupIntent: async function (clientSecretInfo) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/create-set-up-intent`,
      method: "POST",
      withCredentials: true,
      timeout: 10000,
      data: clientSecretInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postAttachPaymentMethodForUser: async function (attachPaymentMethodInfo) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/attach-payment-method`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data: attachPaymentMethodInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postRemovePaymentMethod: async function (paymentMethodInfo) {
    const response = await axiosInstance.request({
      url: `/ecommerce/payment/remove-payment-method`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data: paymentMethodInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postCreateCustomer: async function (userId) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/create-customer`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data: userId,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postCreateRefund: async function (refundInfo) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/create-refund`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data: refundInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postCreateRefundForRoster: async function (refundInfo) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payment/event/refund`,
      method: "POST",
      withCredentials: true,
      timeout: 20000,
      data: refundInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  putUpdateOfflinePaymentHistory: async function (paymenHistoryDetails) {
    const response = await axiosInstance.request({
      url: `/payment-history/update`,
      method: "PUT",
      withCredentials: true,
      timeout: 5000,
      data: paymenHistoryDetails,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
};